/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loved_Quiet_Firefox_GrinInputs */

const fr_loved_quiet_firefox_grin = /** @type {(inputs: Loved_Quiet_Firefox_GrinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensuel`)
};

/**

* @param {Loved_Quiet_Firefox_GrinInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const loved_quiet_firefox_grin = /** @type {((inputs?: Loved_Quiet_Firefox_GrinInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loved_Quiet_Firefox_GrinInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_loved_quiet_firefox_grin(inputs)
});